var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "draggable",
    _vm._b(
      {
        staticClass: "draggable-chip",
        class: _vm.fullWidth
          ? "draggable-chip--is-full-width"
          : "draggable-chip--is-inline",
        attrs: { id: _vm.id, list: _vm.value, move: _vm.move },
        on: { change: _vm.change },
      },
      "draggable",
      _vm.dragOptionsChips,
      false
    ),
    [
      _c(
        "v-chip",
        {
          key: _vm.id,
          staticClass: "draggable-chip__v-chip",
          attrs: { draggable: "", close: "" },
          on: {
            mousedown: function ($event) {
              $event.stopPropagation()
            },
            click: function ($event) {
              $event.stopPropagation()
            },
            input: () => _vm.onChipDeleteClick(_vm.id),
          },
        },
        [
          _c("div", { staticClass: "draggable-chip__content" }, [
            _vm.filterType
              ? _c(
                  "span",
                  { staticClass: "draggable-chip__prepend" },
                  [
                    _vm.filterType === "multiple"
                      ? _c("UiIcon", {
                          attrs: { icon: "im-square-stack-lucide" },
                        })
                      : _vm.filterType === "range"
                      ? _c("UiIcon", {
                          attrs: { icon: "im-sliders-horizontal-phosphor" },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "span",
              { staticClass: "draggable-chip__label" },
              [_vm._t("default")],
              2
            ),
            _vm.hasSettings
              ? _c(
                  "span",
                  { staticClass: "draggable-chip__append" },
                  [
                    _vm.hasSettings
                      ? _c("el-popover", {
                          staticClass: "draggable-chip__popover-trigger",
                          class: { "is-popover-visible": _vm.popoverVisible },
                          attrs: {
                            trigger: "click",
                            placement: "bottom-end",
                            "visible-arrow": false,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "reference",
                                fn: function () {
                                  return [_c("i", { staticClass: "icon-gear" })]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "draggable-chip__popover-menu",
                                      },
                                      [
                                        _c(
                                          "FormField",
                                          { attrs: { label: "Column type:" } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "draggable-chip__popover-highlight-item",
                                              },
                                              [_vm._v(_vm._s(_vm.colData.type))]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "FormField",
                                          { attrs: { label: "Filter type:" } },
                                          _vm._l(
                                            _vm.filterTypes,
                                            function (option, i) {
                                              return _c(
                                                "label",
                                                {
                                                  key: i,
                                                  staticClass:
                                                    "cta-constructor__radio",
                                                  class: [
                                                    {
                                                      active:
                                                        option.value ===
                                                        _vm.filterType,
                                                    },
                                                  ],
                                                },
                                                [
                                                  _c("input", {
                                                    staticClass:
                                                      "cta-constructor__radio-input",
                                                    attrs: {
                                                      type: "radio",
                                                      name: "button",
                                                    },
                                                    domProps: {
                                                      value: option.value,
                                                    },
                                                    on: {
                                                      input: (e) =>
                                                        _vm.$emit(
                                                          "type-change",
                                                          {
                                                            id: _vm.colData.id,
                                                            type: e.target
                                                              .value,
                                                          }
                                                        ),
                                                    },
                                                  }),
                                                  _c("div", {
                                                    staticClass:
                                                      "cta-constructor__radio-indicator",
                                                  }),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "cta-constructor__radio-label",
                                                    },
                                                    [
                                                      _c("UiIcon", {
                                                        attrs: {
                                                          icon: option.icon,
                                                        },
                                                      }),
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(option.label) +
                                                          "\n                  "
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                        _vm.filterType === "range"
                                          ? _c(
                                              "FormField",
                                              {
                                                attrs: { label: "Step value" },
                                              },
                                              [
                                                _c("input", {
                                                  staticClass:
                                                    "cta-constructor__input",
                                                  attrs: {
                                                    name: "step",
                                                    type: "number",
                                                    disabled:
                                                      !_vm.popoverVisible,
                                                  },
                                                  domProps: {
                                                    value: _vm.filterOptions
                                                      ? _vm.filterOptions.step
                                                      : 1,
                                                  },
                                                  on: {
                                                    blur: (e) =>
                                                      _vm.$emit("step-change", {
                                                        id: _vm.colData.id,
                                                        step: e.target.value,
                                                      }),
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2711985707
                          ),
                          model: {
                            value: _vm.popoverVisible,
                            callback: function ($$v) {
                              _vm.popoverVisible = $$v
                            },
                            expression: "popoverVisible",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }